import * as N from "@turf/turf";
const w = {
  additionalStyleFont: "Open Sans",
  additionalStyleFontWeight: "400",
  additionalStyleSize: "12",
  additionalStyleFontColor: "#FFFFFF",
  additionalStyleFontColorOpacity: 100,
  roadLabelType: "CPD",
  roadLabelCustomText: "",
  bgFillColorOpacity: 80,
  dropShadowColorOpacity: 80,
  bgFillColor: "#2F3C44",
  dropShadowColor: "#2F3C44",
  dropShadowHardness: "2",
  bgCornerRadius: 12,
  showRoadLabelNames: !0,
  bgStroke: !1,
  bgEnabled: !0,
  dropShadowEnabled: !0
}, A = (o) => {
  const c = Object.keys(o).map((i) => {
    var a;
    const s = o[i];
    return { [(a = s.properties) == null ? void 0 : a.roadName]: s };
  });
  return Object.assign({}, ...c);
}, k = (o, c, i) => {
  var h, l, L;
  const s = (b) => {
    var y;
    return i.getCarVolumePerDayAtoB && i.getCarVolumePerDayAtoB(b) || ((y = b.properties) == null ? void 0 : y.totalCarsPerDayAtoB);
  }, a = (b) => {
    var y;
    return i.getCarVolumePerDayBtoA && i.getCarVolumePerDayBtoA(b) || ((y = b.properties) == null ? void 0 : y.totalCarsPerDayBtoA);
  }, f = (b) => {
    var y;
    return i.getRoadName && i.getRoadName(b) || ((y = b.properties) == null ? void 0 : y.roadName);
  }, n = N.lineString(o.geometry.coordinates), r = N.length(n) / 2, {
    geometry: { coordinates: t }
  } = N.along(n, r), { angle: p, wasRotated: u } = O(o.geometry.coordinates), D = "rounded", C = s(o) !== 0 && a(o) !== 0 ? "a+b" : a(o) === 0 ? "a-to-b" : "b-to-a";
  return {
    angle: p,
    geolocation: {
      lat: t[1],
      lng: t[0]
    },
    cornerStyle: D,
    drawnType: "RoadLabel",
    visible: !0,
    poiId: (h = o.properties) == null ? void 0 : h.id,
    roadId: (l = o.properties) == null ? void 0 : l.id,
    roadType: (L = o.properties) == null ? void 0 : L.roadType,
    roadName: f(o) || "",
    a_to_b: s(o) || 0,
    b_to_a: a(o) || 0,
    trafficDirection: u ? "b-to-a" : "a-to-b",
    trafficVolumeMetric: C,
    isEditing: !1,
    feature: o,
    year: c,
    styleConfig: w,
    ...i
  };
}, m = (o, c, i, s) => {
  var t, p, u, D, e, C, h;
  if (s === 0)
    return {};
  const a = A(c), f = A(i), n = {}, r = {};
  for (let l = 0; l < o.length; l++) {
    if (!n[(t = o[l].properties) == null ? void 0 : t.roadName] && !a[(p = o[l].properties) == null ? void 0 : p.roadName] && !f[(u = o[l].properties) == null ? void 0 : u.roadName]) {
      const L = c[(D = o[l].properties) == null ? void 0 : D.roadName], b = i[(e = o[l].properties) == null ? void 0 : e.roadName];
      !L && !b && (n[(C = o[l].properties) == null ? void 0 : C.roadName] = o[l], r[(h = o[l].properties) == null ? void 0 : h.id] = o[l]);
    }
    if (Object.keys(n).length === s)
      break;
  }
  return r;
}, B = (o, c, i, s) => {
  const a = {};
  return Object.keys(o).forEach((f) => {
    var p, u;
    const n = o[f], r = ((p = n.properties) == null ? void 0 : p.id) === ((u = s == null ? void 0 : s.properties) == null ? void 0 : u.id), t = k(n, c, {
      ...i,
      isSelected: r
    });
    a[f] = t;
  }), a;
}, E = (o, c, i, s, a, f, n, r, t) => {
  var h, l, L, b, y, P, V;
  const p = B(
    i,
    n,
    {
      tempLabel: !1,
      isLocked: !1
    },
    r
  ), u = B(
    s,
    n,
    {
      tempLabel: !1,
      isLocked: !1
    },
    r
  ), D = B(
    f,
    n,
    {
      tempLabel: !1,
      isLocked: !0
    },
    r
  ), e = {
    ...u,
    ...D
  };
  if (!c) {
    if (!o)
      return {};
    const F = i[(h = r == null ? void 0 : r.properties) == null ? void 0 : h.id];
    if (r && !F) {
      const d = k(r, n, {
        tempLabel: t === ((l = r == null ? void 0 : r.properties) == null ? void 0 : l.id),
        isLocked: !1,
        isSelected: !0
      });
      return {
        [(L = r == null ? void 0 : r.properties) == null ? void 0 : L.id]: d,
        ...e
      };
    }
    return e;
  }
  const C = {
    ...p,
    ...e
  };
  if (r && !C[(b = r == null ? void 0 : r.properties) == null ? void 0 : b.id] && !a[(y = r == null ? void 0 : r.properties) == null ? void 0 : y.id]) {
    const F = k(r, n, {
      tempLabel: t === ((P = r == null ? void 0 : r.properties) == null ? void 0 : P.id),
      isLocked: !1,
      isSelected: !0
    });
    C[(V = r == null ? void 0 : r.properties) == null ? void 0 : V.id] = F;
  }
  return C;
}, M = (o, c, i, s, a) => {
  if (!a)
    return {};
  const f = (r) => {
    const t = c[r.roadId], p = (t == null ? void 0 : t.trafficVolumeMetric) || r.trafficVolumeMetric;
    return {
      ...r,
      trafficVolumeMetric: p,
      styleConfig: o,
      isEditing: s || r.roadId === i
    };
  }, n = {};
  return Object.keys(a).forEach((r) => {
    const t = a[r], p = f(t);
    n[r] = p;
  }), n;
}, O = (o) => {
  let c = 0, i = !1;
  const s = [];
  for (let t = 0; t < o.length - 1; t++) {
    const p = N.lineString([o[t], o[t + 1]]), u = N.length(p) / 2;
    s[t] = u;
  }
  let a = -1, f = 0;
  s.forEach((t, p) => {
    f += t, f >= t && a === -1 && (a = p);
  });
  const n = o[a], r = o[a + 1];
  return c = N.rhumbBearing(n, r), n[0] > r[0] && (c += 180, i = !0), { angle: c, wasRotated: i };
};
export {
  O as computeAngle,
  E as getRoadLabelDataForViewport,
  M as getStyledRoadLabels,
  m as getTopLineSegments,
  k as transformRoadData,
  B as transformToRoadLabels
};
//# sourceMappingURL=index.es482.js.map
